export const getFeedbackAvgRatingColor = (avgRating: number) => {
  if (avgRating >= 80) return 'var(--color-success)';
  if (avgRating >= 60) return 'var(--color-warning)';

  return 'var(--color-error)';
};

export const getFeedbackRatingColor = (rating: number) => {
  if (rating >= 4) return 'var(--color-success)';
  if (rating >= 3) return 'var(--color-warning)';

  return 'var(--color-error)';
};
